import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";

const NAV_ITEMS = [
  { target: "howWork", label: "How IT WOrks?" },
  { target: "aboutUs", label: "About US" },
  { target: "faq", label: "FAQs" },
];

const Header = ({ onJoinWaitlist }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  // On the home page the nav scrolls within the page; on other routes it has to
  // navigate back to "/" first, so fall back to plain anchors.
  const navLink = (target, label, className) =>
    isHome ? (
      <ScrollLink
        to={target}
        spy={true}
        smooth={true}
        offset={50}
        duration={800}
        className={className}
      >
        {label}
      </ScrollLink>
    ) : (
      <a href={`/#${target}`} className={className}>
        {label}
      </a>
    );

  return (
    <header className="max-w-full self-stretch">
      <div className="self-stretch [backdrop-filter:blur(26px)] overflow-hidden flex flex-row items-center justify-between py-[25px] px-10 box-border mix-blend-normal gap-[20px] max-w-full text-left text-xl text-darkslategray-100 font-inter">
        <RouterLink to="/">
          <img
            className="h-[63px] w-[165.6px] cursor-pointer relative overflow-hidden shrink-0 object-contain"
            alt=""
            src="/frame-48095562@2x.png"
          />
        </RouterLink>
        <div className="mq1050:block hidden" onClick={() => setOpen(!open)}>
          <img
            src="/hamburger.png"
            className={`${open ? "hidden" : "block"}`}
            alt=""
          />
          <div className={`${open ? "block" : "hidden"}`}>
            <RxCross2 />
          </div>
        </div>
        <div className="w-[590px] overflow-hidden shrink-0 flex flex-row items-center justify-start px-0 pb-0 box-border gap-[50.7px] max-w-full mq750:gap-[35px] mq1050:hidden mq450:gap-[17px]">
          <div className="relative leading-[20px] uppercase font-medium inline-block min-w-[61px]">
            <RouterLink
              to="/"
              className="no-underline cursor-pointer block	text-black"
            >
              HOME
            </RouterLink>
          </div>
          <div className="relative leading-[20px] uppercase font-medium whitespace-nowrap">
            {navLink(
              "howWork",
              "How IT WOrks?",
              "no-underline cursor-pointer	text-black"
            )}
          </div>
          <div className="relative leading-[20px] uppercase font-medium inline-block min-w-[104px] whitespace-nowrap hover:text-gray-600">
            {navLink(
              "aboutUs",
              "About US",
              "no-underline cursor-pointer	text-black"
            )}
          </div>
          <div className="relative leading-[20px] uppercase font-medium inline-block min-w-[52px]">
            {navLink("faq", "FAQs", "no-underline cursor-pointer	text-black")}
          </div>
        </div>

        <button
          className="cursor-pointer [border:none] py-3 px-[58.5px] bg-[transparent] rounded-81xl [background:linear-gradient(97.56deg,_#472723,_#110302)] flex flex-row items-start mq1050:hidden mq750:hidden mq450:hidden justify-start whitespace-nowrap"
          onClick={onJoinWaitlist}
        >
          <b className="relative text-smi-5 tracking-[-0.14px] leading-[18px] inline-block font-inter text-white text-left min-w-[88px]">
            Join Waitlist
          </b>
        </button>
      </div>
      <div
        className={`flex flex-col justify-between mq450:text-sm mq750:text-xl text-xl font-inter transition duration-500 ${
          open ? "block h-auto py-2" : "hidden"
        }`}
      >
        <RouterLink
          to="/"
          className="no-underline cursor-pointer block pb-2	text-black "
        >
          HOME
        </RouterLink>
        {NAV_ITEMS.map(({ target, label }) => (
          <div key={target}>
            {navLink(
              target,
              label,
              "no-underline cursor-pointer pb-2 block	text-black"
            )}
          </div>
        ))}
      </div>
    </header>
  );
};

export default Header;
